export class OrderCachePaymentResponseResponseDto {
  id: number;
  surfboardOrderId: string;
  surfboardPaymentId: string;
  updated: boolean;
}
